import React, { useState } from 'react';
import { Customer } from '../../../../../core-module/services/logistics/types';
import {
  Delivery,
  DeliveryItem
} from '../../../../../core-module/models/OrderHistory/OrderHistory';
import { Icon, Tag } from 'antd';

interface Props {
  readonly delivery: Delivery;
  readonly item: DeliveryItem[];
  readonly customer: Customer;
}

const OrderHistoryItemComponent: React.FC<Props> = ({ delivery, item, customer }) => {
  const [openIndexes, setOpenIndexes] = useState<number[]>([]);

  const toggleIndex = (index: number) => {
    setOpenIndexes(
      (prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index) // sluiten
          : [...prev, index] // openen
    );
  };

  return (
    <div style={{ color: 'black' }}>
      <h4 style={{ margin: 0, marginTop: '10px', fontWeight: 600 }}>Bezorgadres</h4>
      <div>
        {customer.street_name} {customer.door_number}
        <div>
          {customer.postal_code} {customer.city}
        </div>
      </div>
      <h4 style={{ margin: 0, marginTop: '10px', fontWeight: 600 }}>Inhoud</h4>

      <ul style={{ paddingLeft: '20px' }}>
        {item
          .filter(
            (dish) => !dish.parentSalesOrderItemId && dish.rejectionStatus !== 'CompletelyRejected'
          )
          .map((dish, index: number) => {
            // find child dishes
            const childDishes = item.filter(
              (d) => d.parentSalesOrderItemId === dish.salesOrderItemId
            );
            const hasChildren = childDishes.length > 0;

            return (
              <li key={index} style={{ margin: '1px 0' }}>
                <div onClick={() => toggleIndex(index)} style={{ cursor: 'pointer' }}>
                  <Tag color='#ff9800'>{dish['sequenceNumberOnWeeklyMenu']}</Tag>
                  {dish.quantity}x {dish.productName}, {dish.portion}
                  {hasChildren && (
                    <Icon
                      type='info-circle'
                      style={{
                        marginLeft: 6,
                        color: '#1890ff',
                        cursor: 'pointer'
                      }}
                    />
                  )}
                </div>

                {hasChildren && openIndexes.includes(index) && (
                  <ul style={{ paddingLeft: 16, marginTop: 6 }}>
                    {childDishes.map((child, i) => (
                      <li key={i}>
                        {child.quantity}x {child.productName}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export { OrderHistoryItemComponent };
